import React from 'react';
import { Section } from './ui/Section';
import { X } from 'lucide-react';
import { motion } from 'framer-motion';
export default function OldSolutionsSection() {
  const failures = ['Melatonina (te duerme, pero no apaga el ruido mental).', 'Meditación forzada (intentar poner la mente en blanco solo la agita más).', 'Higiene del sueño estricta (se vuelve otra tarea estresante).', 'Alcohol o pastillas (te noquean, pero no descansas).'];
  return <Section className="bg-brand-dark" data-id="element-253">
      <div className="text-center mb-12" data-id="element-254">
        <h2 className="font-heading text-3xl md:text-5xl text-white leading-tight uppercase tracking-wide" data-id="element-255">
          Por qué las soluciones viejas fallan
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-4 mb-12" data-id="element-256">
        {failures.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.2
      }} className="flex items-start p-4 bg-red-900/10 rounded-lg border border-red-900/20 group hover:bg-red-900/20 transition-colors" data-id="element-257">
            <motion.div initial={{
          scale: 0
        }} whileInView={{
          scale: 1
        }} transition={{
          type: 'spring',
          stiffness: 200,
          delay: index * 0.2 + 0.1
        }} data-id="element-258">
              <X className="text-red-400 mr-4 mt-1 flex-shrink-0 group-hover:rotate-90 transition-transform duration-300" size={24} data-id="element-259" />
            </motion.div>
            <span className={`text-lg md:text-xl text-slate-400 decoration-slate-600 decoration-2 relative ${index === failures.length - 1 ? 'animate-shake' : ''}`} data-id="element-260">
              <span className="relative z-10 opacity-80" data-id="element-261">{item}</span>
              <motion.span initial={{
            width: 0
          }} whileInView={{
            width: '100%'
          }} transition={{
            delay: index * 0.2 + 0.3,
            duration: 0.4
          }} className="absolute top-1/2 left-0 h-0.5 bg-slate-600 -translate-y-1/2 z-20" data-id="element-262" />
            </span>
          </motion.div>)}
      </div>

      <div className="text-center" data-id="element-263">
        <motion.p initial={{
        scale: 0.9,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} transition={{
        delay: 1.5,
        type: 'spring'
      }} className="text-2xl md:text-3xl font-heading text-white uppercase tracking-wide" data-id="element-264">
          Lo que necesitas no es dormir a la fuerza.{' '}
          <span className="bg-brand-indigo/20 text-brand-indigo px-2 py-1 rounded animate-pulse border border-brand-indigo/20" data-id="element-265">
            Es perderle el miedo a estar despierto.
          </span>
        </motion.p>
      </div>
    </Section>;
}